





































import { Component, Vue } from "vue-property-decorator";
import {
  GridColumnTypes,
  GridColumn,
  GridAction,
  GridActionEvent
} from "@/models/grids/column";
import { LanguageDto, MetadataGroupDto, UserTypeDto } from "@/server/app.dtos";
import ConfigsService from "@/services/api/configs.service";
import { Getter } from "vuex-class";
import { FeedbackTypesService } from "@/services/api/feedback.types.service";

@Component
export default class UserTypesPage extends Vue {
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
  apiService: ConfigsService = new ConfigsService();
  feedbackTypesService: FeedbackTypesService = new FeedbackTypesService();
  columns: GridColumn[] = [
    {
      text: "Título",
      value: "title",
      type: GridColumnTypes.Text,
      editable: true,
      editableClass: "col-12",
      editableRules: [this.$rules.minLenght(3)]
    },
    {
      text: "Icon",
      value: "icon",
      type: GridColumnTypes.Text,
      editable: true,
      editableClass: "col-12",
      editableRules: [this.$rules.minLenght(3)]
    },
  ];
  actions: GridAction[] = [
    {
      title: "Opções",
      icon: "las la-ellipsis-v",
      visible: () => false
    }
  ];
  endpoint: string = "api/feedbacktypes";
  primary: string = "idFeedbackType";
  groups: MetadataGroupDto[] = [];
  selectedGroups: number[] = [];
  manageGroupsDialog: boolean = false;
  isValid: boolean = false;
  isLoading: boolean = false;
  currentUserType: UserTypeDto | null = null;

  async created() {
    await this.apiService
      .Load(
        "api/FeedbackTypes",
        "IdLanguage=" + this.currentLanguage.idLanguage
      )
      .then((response: any) => {console.log(response); this.groups = response});
  }

  

  handleAction(data: GridActionEvent) {
    this.currentUserType = data.item;
    this.selectedGroups =
      this.currentUserType != null
        ? this.currentUserType.metadataGroups ?? []
        : [];
    this.manageGroupsDialog = true;
  }
}
